import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import { Autoplay } from 'swiper/modules'
import { useEffect, useState } from 'react'
import { useMainContext } from '../../../core/contexts/main'
import { ReactComponent as Logo } from '../assets/logo.svg'
import Text from '../../../core/utils/Text'
import { ReactComponent as RegisterDark } from '../../../assets/derix/register-dark.svg'
import { ReactComponent as RegisterLight } from '../../../assets/derix/register-light.svg'

const Banners = ({ type }) => {
	const {
		main: { lang, theme },
	} = useMainContext()

	const [swiper, setSwiper] = useState(undefined)
	useEffect(() => {
		if (swiper?.el && lang) swiper.changeLanguageDirection(lang === 'fa' ? 'rtl' : 'ltr')
	}, [swiper, lang])

	const RegisterBanner = theme === 'dark' ? RegisterDark : RegisterLight

	return (
		<div className={'h-full w-full justify-center flex items-center'}>
			<div className={`overflow-hidden w-[70%]`}>
				<Swiper
					modules={[Autoplay]}
					onAfterInit={(swiper) => setSwiper(swiper)}
					autoplay={{
						delay: 2000,
						disableOnInteraction: false,
						pauseOnMouseEnter: false,
					}}
					speed={3000}
					slidesPerView={1}
					loop={true}
				>
					<SwiperSlide className={'relative'}>
						<div className='text-black absolute left-0 bottom-[100px] w-full flex justify-center'>
							<div className='max-w-[80%] text-center flex flex-col items-center gap-2'>
								<span className='text-lg'>
									بازار ارزهای دیجیتال همواره در حال حرکت است و فرصت‌ها منتظر نمی‌مانند.
								</span>
								<span className='text-lg'>
									با ثبت‌نام امروز، شما نه‌تنها به یک صرافی، بلکه به یک زیرساخت حرفه‌ای برای رشد
									مالی خود متصل می‌شوید. آینده سرمایه‌گذاری دیجیتال از همین‌جا آغاز می‌شود.
								</span>
							</div>
						</div>
						<RegisterBanner />
					</SwiperSlide>
				</Swiper>
			</div>
		</div>
	)
}

const InnerTexts = ({ type, color }) => {
	return (
		<div
			className={'absolute left-0 top-0 w-full h-full flex items-center justify-center flex-col'}
		>
			<Logo width={200} />
			{/* <Text tid={`${type}-banner-header`} className={`text-center mt-12 ${color === 'blue' ? 'text-gray-300' : 'text-slate-700'}`} /> */}
			<Text
				tid={`${type}-banner-welcome`}
				className={`text-center mt-2 ${
					color === 'blue' ? 'text-white' : 'text-slate-900'
				} text-2xl`}
			/>
			<Text
				tid={`${type}-banner-desc`}
				className={`max-w-[400px] text-center mt-2 ${
					color === 'blue' ? 'text-gray-300' : 'text-slate-700'
				}`}
			/>
		</div>
	)
}

export default Banners

